import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import { ArrowUp } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';
import { getTypographyFromTheme } from '../../utils/theme/getTypographyFromTheme';

type UseStylesProps = {
  useGreyBackground: boolean;
  fontSize?: number;
};

const useStyles = makeStyles<UseStylesProps>()((theme, { useGreyBackground, fontSize = 12 }) => {
  const typographyBody2 = getTypographyFromTheme(theme.typography.body2);

  return {
    chip: {
      display: 'flex',
      alignItems: 'center',
      height: 'auto',
      paddingLeft: useGreyBackground ? 6 : 0,
      backgroundColor: 'inherit',
      '&:hover': {
        backgroundColor: 'inherit',
      },
      '&.MuiChip-sizeSmall > .MuiChip-label': {
        ...typographyBody2,
        fontSize,
        lineHeight: 1,
        color: theme.palette.text.primary,
      },
      '&.MuiChip-sizeSmall > .MuiChip-icon': {
        marginLeft: 0,
        position: 'relative',
        top: -1,
        color: theme.palette.text.primary,
      },
    },
  };
});

type MarkupChipProps = {
  markupValue: number;
  className?: string;
  fontSize?: number;
  markupTextInLabel?: boolean;
  useGreyBackground?: boolean;
};

const MarkupChip = ({
  className,
  fontSize,
  markupValue,
  markupTextInLabel,
  useGreyBackground = false,
}: MarkupChipProps) => {
  const { classes: styles, cx } = useStyles({ useGreyBackground, fontSize });

  const text = `${markupValue.toFixed(1)} ${markupTextInLabel ? 'markup' : ''}`;

  return (
    <Chip
      className={cx(styles.chip, className)}
      size="small"
      label={text}
      icon={<Icon icon={ArrowUp} size="xs" />}
    />
  );
};

export default MarkupChip;
